module.exports = __webpack_public_path__ + "static/media/pin_protezione_salute_highlighted.2d28e016.png";